/**
 * The Talent Community sign-up link a recruiter pastes into an InMail.
 *
 * `via` is the recruiter's own email name (`annika.lutzenberger`), taken from whoever is signed in
 * — never typed. It is what lets the confirmation emails go out from that recruiter's Gmail later,
 * so nobody has to set anything up per recruiter.
 */
export const JOIN_BASE_URL = 'https://people-space.finn.com/join/community';

/** The part of a FINN address before the @, or null for anything that is not a finn.com address. */
export function recruiterVia(email: string | null | undefined): string | null {
  const m = /^([a-z0-9._+-]+)@finn\.com$/i.exec(`${email || ''}`.trim());
  return m ? m[1].toLowerCase() : null;
}

export function buildJoinLink({
  cluster,
  via,
  language,
}: {
  cluster: string;
  via: string | null;
  language: 'auto' | 'de' | 'en';
}): string {
  const params = new URLSearchParams();
  if (cluster) params.set('cluster', cluster);
  if (via) params.set('via', via);
  if (language !== 'auto') params.set('lang', language);
  const query = params.toString();
  return query ? `${JOIN_BASE_URL}?${query}` : JOIN_BASE_URL;
}
